export default "__VITE_ASSET__31eb997c__"